import { PDF_COLORS, PDF_CONTENT_WIDTH, pdfFz } from "./stylesPDFv2";

// Reparto del cierre: totales a la derecha, con su hueco de separación.
const COLUMN_GAP = 24;
const ANCHO_TOTALES = 46; // %
// Ancho real de la columna de totales: pdfMake resuelve los % sobre el ancho
// disponible YA sin los gaps. El canvas del recuadro necesita puntos, no %.
const ANCHO_CAJA = Math.floor((PDF_CONTENT_WIDTH - COLUMN_GAP) * ANCHO_TOTALES / 100);

const RECUADRO = { fondo: "#F7F8FA", radio: 6, padX: 10, padY: 6 };

// pdfMake solo entiende #RGB y #RRGGBB. Un hex con alfa (#RRGGBBAA) se
// interpreta como un número basura y el panel deja de verse gris claro, así que
// cualquier valor no válido cae al gris por defecto.
const fondoValido = (color) =>
  /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(String(color)) ? color : RECUADRO.fondo;

// Alto del bloque de filas. Cada fila mide su tipografía más su margen vertical
// (ver más abajo), y la divisoria previa al TOTAL suma su línea y sus márgenes.
const altoDeFilas = (filas, emphasizeLast) =>
  filas.reduce((alto, _fila, i) => {
    const esTotal = emphasizeLast && i === filas.length - 1;
    return alto + (esTotal ? pdfFz(11) : pdfFz(8.5)) * 1.3 + (esTotal ? 4 : 6);
  }, emphasizeLast && filas.length > 1 ? 11 : 0);

/**
 * Envuelve los totales en un panel gris de esquinas redondeadas. pdfMake no
 * redondea celdas de tabla, así que el panel se dibuja como canvas y el
 * contenido se sube encima con un margen superior negativo; por eso el alto se
 * calcula de las filas, con holgura vertical para absorber la diferencia entre
 * las métricas reales de la fuente y el estimado.
 */
const enmarcarTotales = (contenido, filas, emphasizeLast, opciones) => {
  const cfg = { ...RECUADRO, ...(opciones && typeof opciones === "object" ? opciones : {}) };
  const alto = Math.round(altoDeFilas(filas, emphasizeLast) + cfg.padY * 2);
  return {
    stack: [
      { canvas: [{ type: "rect", x: 0, y: 0, w: ANCHO_CAJA, h: alto, r: cfg.radio, color: fondoValido(cfg.fondo) }] },
      { margin: [cfg.padX, -(alto - cfg.padY), cfg.padX, cfg.padY], stack: [contenido] },
    ],
  };
};

/**
 * Resumen de totales (Bloque 5, derecha).

 */
/**
 * @param {Array<{label,value}>} rows
 * @param {boolean} emphasizeLast 
 */
export const PDFTotalsSummaryV2 = ({ rows = [], emphasizeLast = true } = {}) => {
  const filas = (rows || []).filter(Boolean);

  if (filas.length === 0) {
    return { text: "" };
  }

  const lastIndex = emphasizeLast ? filas.length - 1 : -1;

  const stackItems = [];

  filas.forEach((r, idx) => {
    const isTotal = idx === lastIndex;

    // ANTES de la fila TOTAL, insertamos el divider como canvas
    if (isTotal && filas.length > 1) {
      stackItems.push({
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 0,
            x2: 228, 
            y2: 0,
            lineWidth: 1,
            lineColor: PDF_COLORS.neutralDivider,
          },
        ],
        margin: [0, 5, 0, 5], // espacio arriba/abajo del divider
      });
    }

    // Fila de label + valor en dos columnas
    stackItems.push({
      columns: [
        {
          text: r.label,
          style: isTotal ? "totalDestacado" : "etiquetaFuerte",
          alignment: "left",
          noWrap: true,
        },
        {
          text: r.value,
          style: isTotal ? "totalDestacado" : "etiquetaFuerte",
          alignment: "right",
          noWrap: true,
          width: 110,
        },
      ],
      columnGap: 6,
      margin: [2, isTotal ? 2 : 3, 2, isTotal ? 2 : 3],
    });
  });

  return { stack: stackItems };
};
/**
 * @param {boolean|object} recuadro panel gris redondeado detrás de los totales.
 *   Opt-in: por defecto los totales van sin fondo, como en ventas. Acepta
 *   { fondo, radio, padX, padY } para ajustarlo. Pensado para cierres que no
 *   destacan una fila TOTAL (la divisoria del TOTAL está dimensionada para la
 *   columna sin recuadro).
 */
export const PDFSummarySectionV2 = ({ left, rows = [], emphasizeLast = true, recuadro = false } = {}) => {
  const filas = (rows || []).filter(Boolean);
  const totales = PDFTotalsSummaryV2({ rows: filas, emphasizeLast });
  return {
    margin: [0, 7, 0, 0],
    unbreakable: true,
    columns: [
      { width: `${100 - ANCHO_TOTALES}%`, stack: [left || { text: "" }] },
      {
        width: `${ANCHO_TOTALES}%`,
        stack: [recuadro && filas.length ? enmarcarTotales(totales, filas, emphasizeLast, recuadro) : totales],
      },
    ],
    columnGap: COLUMN_GAP,
  };
};

export default PDFTotalsSummaryV2;